import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'driversFilter',
    standalone: false
})
export class DriversFilterPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if (!items) return [];
    if (!searchText) return items;

    const searchTerm = searchText.toLowerCase();

    return items.filter(driver => {
      // Search across multiple driver properties
      return (
        (driver.crw_nm && driver.crw_nm.toLowerCase().includes(searchTerm)) ||
        (driver.crw_lcnse_nu && driver.crw_lcnse_nu.toLowerCase().includes(searchTerm)) ||
        (driver.crw_ph && driver.crw_ph.toString().includes(searchTerm)) ||
        (driver.asrt_nm && driver.asrt_nm.toLowerCase().includes(searchTerm)) ||
        (driver.doj && driver.doj.toLowerCase().includes(searchTerm))
      );
    });
  }
}
